class CollapsibleElement extends HTMLElement {
  connectedCallback() {
    const title = this.querySelector(".collapsible__title");
    const content = this.querySelector(".collapsible__content");
    title.setAttribute("active", "false");

    title.addEventListener("click", function () {
      if (title.getAttribute("active") === "true") {
        title.setAttribute("active", "false");
        content.style.height = "0px";
      } else {
        title.setAttribute("active", "true");
        content.style.height = `${content.scrollHeight}px`;
      }
    });
  }
}

customElements.define("collapsible-element", CollapsibleElement);
